
import { container } from '../services/container.js'

var jsSHA = require('jssha')

export const dataLayer = {
  ini() {

    this.cookies = container.get('services.cookies')

    window.addEventListener('quomi.event', (e) => {
  
      if (dataLayer[e.detail.name]) {
        dataLayer[e.detail.name](e.detail.vars);
      }
    })
  },
  authenticate (vars) {
    this.gtc({
      'event': 'userInfo',
      'userId': this.getUserHashed(vars.user)
    })
  },

  changeStep(vars) {

    vars.products = this.getProductsByOrder(vars.order)

    this.gtc({
      'event': 'checkout',
      'ecommerce': {
        'currencyCode': 'EUR',
        'checkout': {
          'actionField': {'step': vars.step},
          'products': vars.products
        }
      }
    });
  },

  getProductsByOrder(order)
  {
    if (!order.extras || !order.recipes) {
      return []
    }

    return order.extras.concat(order.recipes.map(i => {
      let t = i.product; 

      t.quantity = i.quantity

      return t
    })).map(i => {
      return this.formatProduct(i, i.quantity)
    });
  },

  purchase(vars) {
    vars.products = this.getProductsByOrder(vars.order)

    this.gtc({
      'event': 'purchase',
      'ecommerce': {
        'currencyCode': 'EUR',
        'purchase': {
          'actionField': {
            'id': vars.order.id,          
            'revenue': vars.order.prices.net,   
            'shipping': vars.order.prices.delivery,
            'plan': vars.order.plan
          },
          'products': vars.products
        }
      }
    }, 1);

  },

  formatProduct(product, quantity) {
    return {
      'name': product.name,
      'id': product.id,
      'price': product.sell_out ? product.sell_out[2] : 0,
      'brand': window.user.source,
      'category': product.cg1+" "+product.cg2,
      'quantity': Math.abs(quantity)
    }
  },

  updateProductQuantity(vars) {
    let products = {
      'products': [this.formatProduct(vars.product, vars.quantity)],
    }
    if (vars.quantity > 0) {
      this.gtc({
        'event': "addToCart",
        'ecommerce': {
          'currencyCode': 'EUR',
          'add': products,
          'order': {
            'plan': vars.order.plan,
            'revenue': vars.order.prices.net
          }
        }
      })
    } else {
      this.gtc({
        'event': "removeFromCart",
        'ecommerce': {
          'currencyCode': 'EUR',
          'remove': products
        }
      })

    }
  },

  gtc (params, once) {

    var shaObj = new jsSHA('SHA-1', 'TEXT')
    shaObj.update(JSON.stringify(params))
    let hash = 'gtc-' + shaObj.getHash('HEX')


    if (once && localStorage.getItem(hash)) {
      //console.log('DataLayer Skipped', params);
      return 
    }

    //console.log('DataLayer', params);

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(params)

    if (once) {
      localStorage.setItem(hash, 1);
    }
  },

  getUserHashed(user) {


    if (user.email.includes('guest.quomi.it')) {
      return null;
    }

    let param = user.email;
      
    var shaObj = new jsSHA('SHA-256', 'TEXT')

    if (container.get('source').getValue() === 'galbani') {


      let bot = this.cookies.get('CookieConsent');

      if (!bot) {
        console.warn("No cookie 'CookieConsent' found");
        return null;
      }

      bot = JSON.parse(decodeURIComponent(bot));

      console.log(bot);

      if (!bot.marketing) {
        return false;
      }
      
      shaObj.update(param+"m41C4N3S7r0")
    } else {
      shaObj.update(param+"wcGcw98CPqPcXcHk")
    }
      
    return shaObj.getHash('HEX')

  }
}
